import React, { useState } from "react";
import "../../css/CRUDModal.css";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";
import CustomAlert from "../../helpers/CustomAlert";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import CrossIcon from "../../assets/Icons/cross_svg.svg";
import CancelIcon from "@mui/icons-material/Cancel";

const CancelOrderModal = ({
  show,
  handleClose,
  columnData,
  callApi,
  handleMainModalClose
}) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [loading, setLoading] = useState(false);
  const [cancelledByType, setCancellationByType] = useState("CUSTOMER");
  const [remark, setRemark] = useState("");
  const [error, setError] = useState({});  

  const handleBack = () => {
    handleClose();
  };

const handleCancelOrder = async () => {
  const newErrors = {};
  const trimmedRemark = remark.trim();

  if (!trimmedRemark) {
    newErrors.remark = "Remark is required";
  }

  if (Object.keys(newErrors).length > 0) {
    setError(newErrors);
    return;
  }

  setError({});
  setLoading(true);

  try {
     const isShypme = columnData?.orderSubmitSource === "SHYPME";
     const isDelhivery = columnData?.orderSubmitSource === "DIRECT_DELHIVERY";

    const finalPayload = isShypme || isDelhivery
      ? {
          username: loggedInUserName,
          waybill: columnData?.waybill,
          reason: trimmedRemark,
        }
      : {
          username: loggedInUserName,
          orderId: columnData?.id || "",
          cancelledByType,
          remark: trimmedRemark,
        };

    const api = isShypme
      ? apiList.CANCEL_SHYPME_ORDER
      : isDelhivery
      ? apiList.CANCEL_DELHIVERY_ORDER
      : apiList.CANCEL_ORDER;

    const response = await axiosPostApi(api, finalPayload);

    if (
      response?.data?.status === true &&
      response?.data?.respCode === "00"
    ) {
      CustomAlert({
        title: "Order Cancelled",
        text:
          response?.data?.message ||
          "The order has been successfully cancel.",
        icon: "success",
        confirmButtonText: "Okay",
      });
      callApi();
      handleClose();
      handleMainModalClose()
    } else {
      CustomAlert({
        title: "Failed",
        text: response?.data?.message || "Failed to fetch data",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  } catch (error) {
    CustomAlert({
      title: "Error",
      text: "An error occurred while fetching the data. Please try again later.",
      icon: "error",
      confirmButtonText: "Retry",
    });
  } finally {
    setLoading(false);
  }
};

const hideCancelledByType =
  columnData?.orderSubmitSource === "SHYPME" ||
  columnData?.orderSubmitSource === "DIRECT_DELHIVERY";

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "550px",
                borderRadius: "20px",
                padding: "28px",
                backgroundColor: "#ffffff",
                border: "1px solid #e5e7eb",
                boxShadow: "0 8px 40px rgba(0,0,0,0.12)",
                position: "relative",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div
                className="modal-header flex items-center justify-between pb-2"
                style={{
                  borderBottom: "1px solid #dee2e6",
                }}
              >
                <div className="flex items-center gap-2">
                  <CancelIcon
                    style={{ color: "#ff7a00", fontSize: "26px" }}
                  />
                  <h5 className="modal-title main-title font-medium">
                    Cancel Order
                  </h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleBack}
                />
              </div>
              <form>
                <div
                  className="scoped-modal modal-body flex-col"
                  style={{
                    display: "flex",
                    // justifyContent: "center",
                    gap: "24px",
                  }}
                >
                  {!hideCancelledByType && 
                  <div className="flex gap-4 mt-4">
                    <label
                      className="flex items-center gap-3 cursor-pointer p-3 border rounded-lg hover:bg-gray-100 transition"
                      style={{
                        borderColor:
                          cancelledByType === "CUSTOMER" ? "#4f46e5" : "#d1d5db",
                        background:
                          cancelledByType === "CUSTOMER" ? "#f5f5ff" : "white",
                      }}
                    >
                      <input
                        type="radio"
                        name="cancelledByType"
                        value="CUSTOMER"
                        checked={cancelledByType === "CUSTOMER"}
                        onChange={(e) => setCancellationByType(e.target.value)}
                        className="w-5 h-5 accent-indigo-600"
                      />
                      <span className="font-medium text-gray-700 text-[16px]">
                        Cancel By Customer
                      </span>
                    </label>

                    <label
                      className="flex items-center gap-3 cursor-pointer p-3 border rounded-lg hover:bg-gray-100 transition"
                      style={{
                        borderColor:
                          cancelledByType === "LMBP" ? "#4f46e5" : "#d1d5db",
                        background: cancelledByType === "LMBP" ? "#f5f5ff" : "white",
                      }}
                    >
                      <input
                        type="radio"
                        name="cancelledByType"
                        value="LMBP"
                        checked={cancelledByType === "LMBP"}
                        onChange={(e) => setCancellationByType(e.target.value)}
                        className="w-5 h-5 accent-indigo-600"
                      />
                      <span className="font-medium text-gray-700 text-[16px]">
                        Cancel By LMBP
                      </span>
                    </label>
                  </div>
                  }

                  <div className={`w-full mb-4 ${hideCancelledByType && "mt-4"}`}>
                      <label className="block text-gray-700 font-medium mb-1">
                        Remark <span className="text-red-500">*</span>
                      </label>
                    
                      <textarea
                        value={remark}
                        onChange={(e) => {
                           setRemark(e.target.value);
                           setError((prev) => ({ ...prev, remark: "" }));
                         }}
                        placeholder="Enter cancellation remark"
                        rows={3}
                        className="
                          w-full
                          p-3
                          border
                          rounded-lg
                          resize-none
                          focus:outline-none
                          focus:ring-2
                          focus:ring-indigo-500
                          border-gray-300
                        "
                      />
                      {error.remark && (
                         <b className="text-sm text-red-500 error-animate">{error.remark}</b>
                       )}
                  </div>

                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back !rounded-lg"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn btn-submit !rounded-lg"
                    onClick={handleCancelOrder}
                    disabled={loading}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CancelOrderModal;
